<script>
import disciplineList from "@/data/disciplines.json";

export default {
  name: "discipline-selector",
  props: {
    value: {
      type: String,
      default: null
    },
    specialityCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      discipline: this.value
    };
  },
  computed: {
    sortedDisciplineList() {
      return [...(this.discipline ? [null] : []), ...this.disciplineList.sort((a, b) => a.localeCompare(b))];
    },
    disciplineList() {
      return this.specialityCode ? disciplineList[this.specialityCode] || [] : [];
    },
    displayText() {
      return this.discipline ?? "Выберите Дисциплину";
    }
  },
  watch: {
    // Поддержка внешнего обновления v-model
    value: {
      handler(newVal) {
        this.discipline = newVal;
      },
      deep: true
    },
    // Эмитим изменения обратно в родителя
    discipline: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  }
};
</script>

<template>
  <b-dropdown
    :text="displayText"
    boundary="viewport"
    menu-class="dropdown-menu-custom"
    no-caret
    size="sm"
    variant="outline-dark"
  >
    <b-dropdown-item
      v-for="item in sortedDisciplineList"
      :key="item"
      class="dropdown-item-custom"
      @click="discipline = item"
    >
      {{ item ?? "Любое" }}
    </b-dropdown-item>
  </b-dropdown>
</template>


<style scoped>
/* Добавьте стили при необходимости */
</style>
